import React, { useEffect, useState } from 'react'

import GalleryInput from '../../../../../components/form/GalleryInput'
import { usePdfOptionsFormActions } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import { useDocumentHeader, useDocumentHeaderValue } from '../../general/documentHeader/_load/DocumentHeaderLoader'
import { useSaveDocumentHeader } from '../../general/documentHeader/_requests/saveDocumentHeader'
import { useRemoveDocumentHeader } from '../../general/documentHeader/_requests/removeDocumentHeader'
import ListItemWrapper from '../../../../../components/list/ListItemWrapper'
import DropdownListItem from '../../../../../components/list/DropdownListItem'
import { useSessionPermission } from '@btime/react-session'

const OPTIONS = [
  { label: 'Muito pequeno (50px)', value: '50px' },
  { label: 'Pequeno (80px)', value: '80px' },
  { label: 'Médio (90px)', value: '90px' },
  { label: 'Grande (100px)', value: '100px' },
  { label: 'Muito grande (150px)', value: '150px' },
  { label: 'Gigante (180px)', value: '180px' }
]

const HeaderContent = () => {
  const { handleChange } = usePdfOptionsFormActions()
  const [saveImage, { loading: loadingImage }] = useSaveDocumentHeader()
  const [removeImage, { loading: removingImage }] = useRemoveDocumentHeader()
  const documentHeaderValue = useDocumentHeaderValue()
  const documentHeader = useDocumentHeader()
  const [imageHeight, setImageHeight] = useState(
    (documentHeaderValue && documentHeaderValue[0]?.height) || OPTIONS[0].value
  )
  const hasResumePdfHeaderImagePermission = useSessionPermission('useResumePdfHeaderImage')

  useEffect(() => {
    handleChange('headerImage', documentHeaderValue)
  }, [documentHeaderValue])

  const handleChangeHeight = selectedOption => {
    setImageHeight(selectedOption)
    save(documentHeaderValue, selectedOption)
  }

  const handleChangeImage = image => {
    if (!image?.length) {
      removeImage(documentHeader.id)
      return
    }
    save(image, imageHeight)
  }

  const save = (image, imageHeight) => {
    image[0].height = imageHeight
    handleChange('headerImage', image)
    saveImage({ ...documentHeader, value: image })
  }

  return hasResumePdfHeaderImagePermission ? (
    <>
      <ListItemWrapper bgColor={'transparent'}>
        <Text>{'Imagem de cabeçalho'}</Text>
        <GalleryInput
          multiple={false}
          limit={1}
          colWidth="80%"
          thumbHeight="6rem"
          value={documentHeaderValue}
          onChange={handleChangeImage}
          buttonLabel="Adicionar"
          buttonHeight="4rem"
          isLoading={loadingImage || removingImage}
          accept={'image/*'}
          gap={0.3}
        />
      </ListItemWrapper>
      {documentHeaderValue && (
        <DropdownListItem
          bottomDistance={'10px'}
          onChange={handleChangeHeight}
          label="Altura da imagem"
          value={imageHeight}
          options={OPTIONS}
          invert
        />
      )}
    </>
  ) : (
    <></>
  )
}

export default HeaderContent
